import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
  Icon,
} from "@qw/ui";
import type { FC } from "react";
import type { ConversationMenuItem } from "@/providers/use-conversation-menu";

interface ConversationLinkProps extends React.PropsWithChildren {
  menuItems: ConversationMenuItem[];
}

export const ConversationLinkMenu: FC<ConversationLinkProps> = ({ children, menuItems }) => {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <ContextMenuContent hidden={!menuItems?.length}>
        {menuItems.map((item, index) =>
          item.type === "separator" ? (
            <ContextMenuSeparator key={index} />
          ) : (
            <ContextMenuItem key={index} disabled={item.disabled} onClick={item.onClick}>
              {item.icon && <Icon icon={item.icon} {...item.iconProps} />}
              {item.label}
            </ContextMenuItem>
          )
        )}
      </ContextMenuContent>
    </ContextMenu>
  );
};
